import {
    InterruptionReferenceModel,
    InterruptionReferenceModelAPI,
} from '../../../../models';

export const getInterruptionReferenceTypesListAdapter = (
    responseAPI: InterruptionReferenceModelAPI[]
): InterruptionReferenceModel[] => {
    return responseAPI
        ? responseAPI.map((interruptionReference) => {
              return {
                  id: interruptionReference.id,
                  isActive: interruptionReference.isActive,
                  name: interruptionReference.name,
              };
          })
        : [];
};
